import { Injectable      } from '@angular/core';
import { LanguageSession } from 'src/app/services/sessions/language.session';
import { UserSession     } from 'src/app/services/sessions/user.session';
import { MenuSession     } from 'src/app/services/sessions/menu.session';
import { LocaleSession } from 'src/app/services/sessions/locale.session';
import { OrganizationSession } from 'src/app/services/sessions/org.session';
import { HubSession } from 'src/app/services/sessions/hub.session';
import { GuidedCreationSession } from 'src/app/services/sessions/guided.creation.session';
import { CodeSession } from 'src/app/services/sessions/code.session';

@Injectable({
  providedIn: 'root'
})
export class SessionManager {

  constructor
  (
    private _language       : LanguageSession      ,
    private _user           : UserSession          ,
    private _menu           : MenuSession          ,
    private _locale         : LocaleSession        ,
    private _org            : OrganizationSession  ,
    private _hub            : HubSession           ,
    private _guided_creation: GuidedCreationSession,
    private _code           : CodeSession
  ) {}

  language()
  {
    return this._language
  } 

  user()
  {
    return this._user
  } 

  menu()
  {
    return this._menu
  } 

  locale()
  {
    return this._locale
  } 

  org()
  {
    return this._org
  }

  hub()
  {
    return this._hub
  }

  guidedCreation()
  {
    return this._guided_creation
  }

  code(){
    return this._code

  }
}
